import DEVICE_BREAKPOINTS from '../constants/deviceBreakpoints';

const {
  MOBILE, TABLET, LAPTOP, LARGESCREEN
} = DEVICE_BREAKPOINTS;

export const atMobileSmaller = query => `
  @media only screen and (max-width: ${MOBILE - 1}px) {
    ${query}
  }
`;

export const atTabletSmaller = query => `
  @media only screen and (max-width: ${TABLET - 1}px) {
    ${query}
  }
`;

export const atLaptopSmaller = query => `
  @media only screen and (max-width: ${LAPTOP - 1}px) {
    ${query}
  }
`;

export const atMobileLarger = query => `
  @media only screen and (min-width: ${MOBILE}px) {
    ${query}
  }
`;

export const atTabletLarger = query => `
  @media only screen and (min-width: ${TABLET}px) {
    ${query}
  }
`;

export const atLaptopLarger = query => `
  @media only screen and (min-width: ${LAPTOP}px) {
    ${query}
  }
`;

export const atLargeScreenLarger = query => `
  @media only screen and (min-width: ${LARGESCREEN}px) {
    ${query}
  }
`;